/**
 * Dawn: details-modal.js (SAFE PATCH)
 * Prevents Theme Editor / pages from crashing if expected DOM nodes are missing.
 * If the modal element isn't present, it simply does nothing.
 */

class DetailsModal extends HTMLElement {
  constructor() {
    super();

    // Dawn normally expects a <details> and close button inside this component.
    // If markup is missing (common when stripping theme), don't crash.
    this.details = this.querySelector('details');
    this.closeButton = this.querySelector('button[type="button"], .modal__close-button, [data-close]');

    if (!this.details) return;

    // Bind safely
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onBodyClick = this.onBodyClick.bind(this);

    document.addEventListener('keyup', this.onKeyUp);

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    // Clicking outside closes (if desired)
    document.addEventListener('click', this.onBodyClick);
  }

  disconnectedCallback() {
    document.removeEventListener('keyup', this.onKeyUp);
    document.removeEventListener('click', this.onBodyClick);
  }

  onKeyUp(event) {
    if (event.key === 'Escape') this.close();
  }

  onBodyClick(event) {
    // Only close if open and click was outside the details content
    if (!this.details || !this.details.hasAttribute('open')) return;
    if (this.contains(event.target)) return;
    this.close();
  }

  close() {
    if (!this.details) return;
    this.details.removeAttribute('open');
  }
}

// Define only once
if (!customElements.get('details-modal')) {
  customElements.define('details-modal', DetailsModal);
}